import { Check, Close } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React, { useState } from 'react';
import { LabelWithoutEventBubbling } from "../../helper/components/LabelWithoutEventBubbling.js";
import { useStableId } from "../../helper/hooks/useStableId.js";
import styles from "./Toggle.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Toggle = ({
  id,
  onFocus,
  onBlur,
  onClick,
  children,
  className,
  inputRef,
  labelPlacement = 'left',
  ...inputProps
}) => {
  const [focused, setFocused] = useState(false);
  const classes = classnames(styles.toggle, {
    [styles.focused]: focused,
    [styles.checked]: inputProps.checked,
    [styles.disabled]: inputProps.disabled
  }, className);
  const inputId = useStableId(id);
  function handleClick(e) {
    // This line is to difference between pressing an arrow key and a real mouse click
    // https://github.com/facebook/react/issues/7407
    if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
      e.currentTarget.blur();
    }
    onClick?.(e);
  }
  function handleFocus(e) {
    setFocused(true);
    onFocus?.(e);
  }
  function handleBlur(e) {
    setFocused(false);
    onBlur?.(e);
  }
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [labelPlacement === 'left' && children && /*#__PURE__*/_jsx(LabelWithoutEventBubbling, {
      htmlFor: inputId,
      className: styles.label,
      children: children
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.track,
      children: [/*#__PURE__*/_jsx(Check, {
        size: "SMALL",
        className: styles.icon
      }), /*#__PURE__*/_jsx("div", {
        className: styles.thumb
      }), /*#__PURE__*/_jsx(Close, {
        size: "SMALL",
        className: styles.icon
      }), /*#__PURE__*/_jsx("input", {
        ...inputProps,
        id: inputId,
        onClick: handleClick,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref: inputRef,
        type: "checkbox",
        className: styles.input
      })]
    }), labelPlacement === 'right' && children && /*#__PURE__*/_jsx(LabelWithoutEventBubbling, {
      htmlFor: inputId,
      className: styles.label,
      children: children
    })]
  });
};